import * as React from "react";
import * as R from "ramda";
import {Form} from "react-final-form";
import {Col, Row} from "react-bootstrap";
import TipoIdentificacion from "../../general/componentes/TipoIdentificacion";
import NumericInput from "../../general/componentes/NumericInput";
import TipoCliente from "../../general/componentes/TipoCliente";
import {connect} from "react-redux";
import TablaDocumentos from "./TablaDocumentos";
import {consultarDocumentos} from "../modulos/documentosActions";
import DatePickerSura from "../../general/componentes/DatePicker";
import {Documento, FiltroDocumento} from "../modelo/Documento";
import InformacionBasicaDocumento from "./InformacionBasicaDocumento";
import {REQUEST} from "../../../config/ajax-wrapper";
import {Mensaje} from "../../general/componentes/Mensaje";
import {DotLoader} from "react-spinners";
import TipoTramite from "../../bandeja/componentes/TipoTramite";
import { TIPO_GESTION } from "../modelo/TipoGestion";

class Documentos extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const { documentos, estado, paginas, tamanoPagina, paginaActual } = this.props;
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({handleSubmit, invalid, errors, form, submitting, pristine, values}) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Aprobar Solicitudes</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar documentos</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label htmlFor="tipoDocumento">Tipo Documento</label>
                                                <TipoIdentificacion name="tipoDocumento"/>
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="documento">Documento</label>
                                                <NumericInput name="documento" placeholder="Ingrese un documento"/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Inicio</label>
                                                <DatePickerSura name={"fechaInicio"}/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Fin</label>
                                                <DatePickerSura name={"fechaFin"}/>
                                            </Col>
                                        </Row>
                                        <Row className="form-group">
                                            <Col sm={3}>
                                                <label>Tipo Cliente</label>
                                                <TipoCliente name="tipoCliente" excluir={["DE","OI"]}/>
                                            </Col>
                                            <Col sm={3}>
                                                <label>Tipo de Tramite</label>
                                                <TipoTramite name={"tipoTramite"}/>
                                            </Col>
                                        </Row>
                                        <Row className="form-group">
                                            <Col smOffset={7} sm={1}>
                                                <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                    Limpiar
                                                </button>
                                            </Col>
                                            <Col sm={1}>
                                                <button type="submit" className="btns btns-primary"
                                                        disabled={submitting || invalid}>
                                                    Consultar
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderDocumentos(documentos, estado,paginas,tamanoPagina,paginaActual)}
                </Row>
            </div>
        );
    }

    filtros(): FiltroDocumento {
        return {
            dni: this.state.dni,
            tipoCliente: this.state.tipoCliente,
            tipoTramite: this.state.tipoTramite,
            fechaInicio: this.state.fechaInicio,
            fechaFin:   this.state.fechaFin,
        };   
        
    }

    consultaPaginada = (filtroDocumento: FiltroDocumento) => {
        this.props.dispatch(consultarDocumentos(filtroDocumento));
    };

    renderDocumentos(documentos: Array<Documento>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error consultando los documentos"}/>;
            case REQUEST.PENDING:
                return <DotLoader size={25}/>;
            case REQUEST.SUCCESS:
                const mensajeUsuario = !this.props.mensajeUsuario ? "" : (
                    <Mensaje type={this.props.mensajeUsuario.type}
                             mensaje={this.props.mensajeUsuario.text}/>
                );
                if (!documentos || documentos.length === 0 ) {
                    return (
                        <span>
                            {mensajeUsuario}
                            <Mensaje type={"danger"} mensaje={"No hemos encontrado documentos :("}/>
                        </span>
                    );
                } else {
                    return (
                        <span>
                        {mensajeUsuario}
                            {documentos.length === 1 ? <InformacionBasicaDocumento documento={documentos[0]}/> :
                                <TablaDocumentos 
                                    estado={this.props.estadoReintento}
                                    documentos={documentos} 
                                    filtroDocumento={this.filtros()}
                                    consultaPaginada={this.consultaPaginada}
                                    paginas={paginas} 
                                    tamanoPagina={tamanoPagina}
                                    paginaActual={paginaActual}
                                    tipoGestion={TIPO_GESTION.DOCUMENTOS_AFILIACION_DIRECTA}
                                />}
                        </span>
                    );
                }
            default:
                return false;
        }
    }

    validate = values => {
        const errors = {documento: undefined, tipoDocumento: undefined, fechaInicio: undefined, fechaFin: undefined};

        if (values.tipoDocumento && !values.documento) {
            errors.documento = "Por favor ingrese un documento";
        }

        if (!values.tipoDocumento && values.documento) {
            errors.tipoDocumento = "Por favor selecciona un tipo de documento";
        }

        if (values.fechaInicio && !values.fechaFin) {
            errors.fechaFin = "Por favor selecciona una fecha de fin";
        }

        if (!values.fechaInicio && values.fechaFin) {
            errors.fechaInicio = "Por favor selecciona una fecha de inicio";
        }

        if (values.fechaInicio && values.fechaFin &&
            (values.fechaInicio.isAfter(values.fechaFin))) {
            errors.fechaFin = "La fecha fin no puede ser anterior a la fecha de inicio";
        }

        return errors;
    };

    onSubmit = values => {
        const dni = values.tipoDocumento && values.documento ? (values.tipoDocumento + values.documento) : undefined;
        const tipoCliente = values.tipoCliente ? values.tipoCliente.valueOf() : "";
        const tipoTramite = values.tipoTramite ? values.tipoTramite.valueOf() : "";
        
        const fechaInicio = values.fechaInicio ? values.fechaInicio.valueOf() : "";
        const fechaFin = values.fechaFin ? values.fechaFin.valueOf() : "";

        const filtroDocumento: FiltroDocumento = {
            dni: dni, 
            tipoCliente: tipoCliente, 
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0,
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            tipoTramite: tipoTramite 
        };

        this.setState(
            {
                dni: dni, 
                tipoCliente: tipoCliente, 
                estado: values.estado, 
                tipoTramite: tipoTramite,
                fechaInicio: fechaInicio,
                fechaFin: fechaFin, 
            }
        );

        this.props.dispatch(consultarDocumentos(filtroDocumento));
    }

}

export default connect((store: any) => {
    return {
        documentos: R.pathOr([], ["documentos", "documentos"])(store),
        estado: R.pathOr(REQUEST.NONE, ["documentos", "estado"])(store),
        mensajeUsuario: R.pathOr(false, ["documentos", "mensajeUsuario"])(store),
        tamanoPagina: R.pathOr([], ["documentos", "tamanoPagina"])(store),
        paginaActual: R.pathOr([], ["documentos", "paginaActual"])(store),
        paginas: R.pathOr(1, ["documentos", "paginas"])(store)
    };
})(Documentos);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/Documentos.tsx